import { Button, Col, Row } from "antd";
import React from "react";
import NotFound from "../assets/404.png";
import { useNavigate } from "react-router-dom";

function PageNotFound() {
  const navigate = useNavigate();
  return (
    <Row>
      <Col md={12} sm={24}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "10rem",
            marginTop: "30vh",
          }}
        >
          <span
            style={{
              fontSize: "30px",
              fontWeight: "700",
              marginBottom: "0.4rem",
            }}
          >
            OOPS...
          </span>
          <span style={{ fontSize: "20px", fontWeight: "500" }}>
            Page not Found
          </span>
          <Button
            style={{
              width: "30%",
              backgroundColor: "#3052D0",
              color: "white",
              marginTop: "2rem",
            }}
            onClick={() => navigate("/dashboard")}
          >
            Go Back
          </Button>
        </div>
      </Col>
      <Col md={12} sm={24}>
        <img
          src={NotFound}
          alt="notFound-logo"
          style={{
            marginRight: "1rem",
            marginTop: "4rem",
          }}
        />{" "}
      </Col>
    </Row>
  );
}

export default PageNotFound;
